<template>
  <div>
    <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="contact-info__promo">{{ $t('promo.promocode') }}</label>
    <div class="octobus__field has-addons">
      <div class="octobus__control">
        <input
          class="octobus__input is-medium"
          type="text"
          :placeholder="$t('promo.placeholder')"
          id="contact-info__promo"
          v-model="promocode"
        />
      </div>
      <div class="octobus__control">
        <a class="octobus__button is-medium" :class="{'is-loading': checking}" @click="onSubmit">
            Ок
        </a>
      </div>
    </div>
    <p v-show="error" class="octobus__help is-danger">{{ error }}</p>
  </div>
</template>

<script>
import api from '@/api';
import { getBuyerId } from '@/utils/utils';

export default {
  name: 'Promocode',
  props: {
    tripId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      promocode: '',
      error: '',
      checking: false,
    };
  },
  computed: {
  },
  methods: {
    async onSubmit() {
      const promocode = this.promocode.trim();

      if (promocode) {
        const buyerId = getBuyerId();
        if (!buyerId) {
          this.showError(this.$t('promo.noauth'));
          return false;
        }

        this.error = '';
        this.checking = true;
        try {
          const response = await api.Content.promo(promocode, this.tripId, buyerId);

          if (response.error) {
            this.showError(this.$t('promo.apiError'));
          } else if (!response.find(p => p.applicable)) {
            this.showError(this.$t('promo.notApplicable'));
          } else {
            this.$EventBus.$emit('promocode__set', response);
          }
        } catch (e) {
          this.showError(this.$t('promo.apiError'));
          throw e;
        }
      }

      this.checking = false;
      return true;
    },
    showError(error) {
      this.error = error;
    },
  },
};
</script>

<style scoped lang="scss">

/* Small Devices, Tablets */
@media only screen and (max-width : 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/ContactInfo/Promocode.vue